module.exports = __webpack_public_path__ + "img/help10.c813a35c.png";